/* eslint-disable max-len */
import React from "react";
import { ModalRoute } from "seed/helpers";
import l from "components/util/l";
import Guides from "components/studio/toolbox/guides/Guides"
import Actions from "components/studio/toolbox/actions/Actions"
import Executions from "components/vmisc/executions/Executions";
import Collections from "components/collections/Collections";
import Apps from "components/studio/toolbox/actions/apps/Apps";
import Versions from "components/studio/rightnav/versions/Versions";
import SidenavItem from "components/studio/toolbox/Toolbox.sub.SidenavItem.view";
import GuidesVisualizer from "components/studio/toolbox/guides/GuidesVisualizer";
import "styles/css/studio/Toolbox.css";


const ToolboxView = ({
  toolboxRef,
  studioRef,
  flow,
  pageId,
  toolboxId,
  defAppId,
  activeSection,
  activeActionId,
  nodes,
  nodeParams,
  reqApps,
  reqAllApps,
  showTabs,
  defaultWizardMode,
  wizardFlow,
  isCollapsed,
  isAnonymous,
  isValidator,
  isWizardAssistant,
  onClickNode,
  onClickSidenavItem,
  onChangeMode,
  reloadFlow
}) => (
  <div id="toolbox-container"
    className={"d-flex h-100 " +
      (activeSection + "-section ") +
      (isCollapsed && !isValidator ? "collapsed " : " ") +
      (showTabs && !isValidator ? "include-tabs " : " ")}>

    {showTabs && !isValidator ? (
      <div id="toolbox-sidenav" className="d-flex flex-column h-100"
        style={{ boxSizing: "border-box", overflowY: "auto" }}>

        <SidenavItem
          name="actions"
          label={l("Acciones%GA005")}
          icon="fas fa-shapes"
          activeSection={!isCollapsed ? activeSection : null}
          onClickItem={onClickSidenavItem} />

        <SidenavItem
          name="data"
          label={l("Datos%GA035")}
          icon="fas fa-table"
          activeSection={!isCollapsed ? activeSection : null}
          onClickItem={onClickSidenavItem} />

        <SidenavItem
          name="versions"
          label={l("Versiones%SA171")}
          icon="fas fa-clock-rotate-left"
          activeSection={!isCollapsed ? activeSection : null}
          onClickItem={onClickSidenavItem} />

       

        <div style={{ height: "1px", background: "#00000040", margin: "1.1rem 0.85rem 1.2rem 0.85rem" }} />

         <SidenavItem
          name="executions"
          label={l("Pruebas%SA004")}
          icon="fas fa-play"
          activeSection={!isCollapsed ? activeSection : null}
          onClickItem={onClickSidenavItem} />
        

        <SidenavItem
          name="guides"
          label={l("Guías%SA014")}
          icon="fas fa-graduation-cap"
          iconStyle={{ fontSize: "1.54rem" }}
          activeSection={!isCollapsed ? activeSection : null}
          onClickItem={onClickSidenavItem} />

      </div>
    ) : null}

    {!isCollapsed ?
      <div id="toolbox-content">

        {activeSection == "actions" ?
          <Actions
            toolboxRef={toolboxRef}
            studioRef={studioRef}
            flowId={flow.id}
            defAppId={defAppId}
            activeActionId={activeActionId}
            nodes={nodes}
            nodeParams={nodeParams}
            toolboxId={toolboxId}
            reqApps={reqApps}
            reqAllApps={reqAllApps}
            defaultWizardMode={defaultWizardMode}
            wizardFlow={wizardFlow}
            isAnonymous={isAnonymous}
            isValidator={isValidator}
            isWizardAssistant={isWizardAssistant}
            onClickNode={onClickNode}
            onChangeMode={onChangeMode}
            reloadFlow={reloadFlow}
          /> : null}


        {activeSection == "data" &&
          <Collections
            flow={flow}
          />}

        {activeSection == "guides" &&
          <div className="px-2 py-3">
            <Guides />
          </div>}

        {activeSection == "executions" ?
          <div className="pt-4 h-100 overflow-auto">
            <Executions
              flow={flow}
              styles={{ height: "100%" }}
              showDebugOnly={true}
            /></div> : null}

        {activeSection == "versions" &&
          <div className="px-2 pt-4 h-100 overflow-auto">
            <Versions flow={flow} />
          </div>}

        {/*Temp hide 250807
        activeSection == "templates" &&
          <Templates
            flowId={flow.id}
          /> */}

      </div>
      : null}


    <ModalRoute
      height="600"
      path={"/apps"}
      component={() =>
        <div className="card">
          <div class="card-header d-flex justify-content-between"><h3 class="mb-0">{l("Acciones%GA005")}</h3></div>
          <Apps reqApps={reqApps} flowId={flow.id} />
        </div>}
    />

    <ModalRoute
      width={`${window.innerWidth - 100}`}
      height={`${window.innerHeight - 100}`}
      path={"/guides/:guideId"}
      component={GuidesVisualizer}
    />

  </div>

);

export default ToolboxView;
